export const getCurrentTime = (expiry) => {
        const expiryDate = new Date(expiry);
        const diff = expiryDate - new Date();
    
        const minutes = Math.floor(diff / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        console.log("minutes", diff);
        console.log("seconds", seconds);
        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
      };

